export default "__VITE_ASSET__b806cf3c__"